(function () {
  if (window.__flycoPetSeriesModalLoaded) return;
  window.__flycoPetSeriesModalLoaded = true;

  var pathname = window.location.pathname.toLowerCase();

  if (pathname.indexOf('pet') === -1) return;

  var petImageWasUploaded = false;
  var petImageWasCleared = false;
  var confirmedUntil = 0;
  var petImagePropertyKey = "Upload Your Pet's Photo";
  var defaultImageUrlMarker = '/initialImages/';
  var defaultImageMessage = 'Are you sure that you opt for the default pet image?';
  var emptyImageMessage = 'Are you sure you want to add to cart without a pet image?';

  function hasValue(value) {
    return typeof value === 'string' && value.trim() !== '';
  }

  function isDefaultImageValue(value) {
    return hasValue(value) && value.indexOf(defaultImageUrlMarker) !== -1;
  }

  function hasSelectedUploadFile() {
    var fileInputs = document.querySelectorAll('#cl_optionsapp input[type="file"], .customily_option input[type="file"], input[type="file"][name*="customily"], input[type="file"][name*="Customily"], input[type="file"][name*="upload"], input[type="file"][name*="Upload"]');

    for (var index = 0; index < fileInputs.length; index += 1) {
      if (fileInputs[index].files && fileInputs[index].files.length > 0) return true;
    }

    return false;
  }

  function isClearUploadControl(element) {
    var control = element && element.closest('button, a, [role="button"], [class*="remove"], [class*="Remove"], [class*="delete"], [class*="Delete"], [class*="clear"], [class*="Clear"]');

    if (!control) return false;

    var controlText = (control.textContent || '').toLowerCase();
    var className = typeof control.className === 'string' ? control.className : '';
    var identifier = ((control.id || '') + ' ' + className).toLowerCase();

    return controlText.indexOf('remove') !== -1 ||
      controlText.indexOf('delete') !== -1 ||
      controlText.indexOf('clear') !== -1 ||
      identifier.indexOf('remove') !== -1 ||
      identifier.indexOf('delete') !== -1 ||
      identifier.indexOf('clear') !== -1;
  }

  function isWithinCustomilyUpload(element) {
    return !!(element && element.closest('#cl_optionsapp, .customily_option, [class*="customily"], [class*="Customily"], [id*="customily"], [id*="Customily"], [class*="upload"], [class*="Upload"], [id*="upload"], [id*="Upload"]'));
  }

  function getPetImageState() {
    var input = document.querySelector('input[name="properties[' + petImagePropertyKey + ']"]');

    if (input && hasValue(input.value)) {
      return isDefaultImageValue(input.value) ? 'default' : 'uploaded';
    }

    if (petImageWasUploaded || hasSelectedUploadFile()) return 'uploaded';
    if (petImageWasCleared) return 'empty';

    return 'default';
  }

  document.addEventListener('change', function (event) {
    var input = event.target;

    if (!input || input.type !== 'file') return;

    petImageWasUploaded = input.files && input.files.length > 0;
    petImageWasCleared = !petImageWasUploaded;
  }, true);

  document.addEventListener('click', function (event) {
    if (!isWithinCustomilyUpload(event.target) || !isClearUploadControl(event.target)) return;

    petImageWasUploaded = false;
    petImageWasCleared = true;
  }, true);

  document.addEventListener('click', function (event) {
    var atcButton = event.target.closest('button[type="submit"][name="add"], button[name="add"], #AddToCart, .product-form__submit');

    if (!atcButton) return;

    var petImageState = getPetImageState();

    if (petImageState === 'uploaded') return;
    if (Date.now() < confirmedUntil) return;

    if (!window.confirm(petImageState === 'default' ? defaultImageMessage : emptyImageMessage)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    confirmedUntil = Date.now() + 15000;
  }, true);
})();
